import { Button, Form, InputNumber, Modal, Radio, Tabs } from 'antd';
import React, { useState } from 'react';
import IntlMessages from '../../components/IntlMessage';
import rateApi from '../../api/rates';
import { useIntl } from 'react-intl';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const RateForm = (props) => {
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const intl = useIntl();

  let initialValues = {
    adult_price:
      currentData && currentData.adult_price ? currentData.adult_price : null,
    child_price:
      currentData && currentData.child_price ? currentData.child_price : null,
    infant_price:
      currentData && currentData.infant_price ? currentData.infant_price : null,
    seat: currentData && currentData.seat ? currentData.seat : '',
    status: currentData && currentData.status ? 1 : 0,

    //images: currentData && currentData.images ? currentData.images : "",
    //code: currentData && currentData.code ? currentData.code : "",
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        //data.propertytypes = JSON.stringify(data.propertytypes);

        if (currentData) {
          rateApi
            .update(currentData.id, data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          rateApi
            .create(data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessages id="global.tour_rates" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.adult_price" />}
            name="adult_price"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.child_price" />}
            name="child_price"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessages id="global.infant_price" />}
            name="infant_price"
            rules={[
              {
                required: false,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
          {/* <Form.Item
            label={<IntlMessages id="global.seat" />}
            name="seat"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
              style={{ width: '100%' }}
            />
          </Form.Item> */}
          <Form.Item name="status" label={<IntlMessages id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessages id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessages id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessages id="global.edit" />
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems} />
      </Form>
    </Modal>
  );
};

export default RateForm;
